// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { toast } from "react-toastify";
// import { 
//   Users, CheckCircle2, Clock, Eye, 
//   Award, X, Layers, Search, Calendar, Play, Trash2, Cpu
// } from "lucide-react";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import PageLoader from "../../helpers/PageLoader";
// import SelectDropdown from "../../customStyles/SelectDropdown";
// import ModernTable from "../ui/ModernTable";
// import DeleteConfirmationOffcanvas from "../../helpers/DeleteConfirmationOffcanvas";
// import { formatDateTime } from "../../helpers/formatDateTime";

// // ✅ FIXED: Reordered conditions to prevent substring mismatch on "MONTH"
// const getAvailablePeriods = (reviewCycle, year) => {
//   const fyYear = Number(year) || new Date().getFullYear();
//   const normalizedCycle = String(reviewCycle).toUpperCase().replace(/\s+/g, "_");

//   const getLastDayOfMonth = (yr, month) => {
//     return new Date(yr, month, 0).getDate(); 
//   };

//   const pad = (num) => String(num).padStart(2, '0');

//   // 1. ANNUAL (12 Months Interval) - Checked first to avoid substring clash
//   if (
//     normalizedCycle.includes("12_MONTH") || 
//     normalizedCycle.includes("ANNUAL") || 
//     normalizedCycle.includes("YEAR")
//   ) {
//     return [
//       { label: "Annual (Apr - Mar)", value: "ANNUAL", startDate: `${fyYear}-04-01`, endDate: `${fyYear + 1}-03-31` }
//     ];
//   }

//   // 2. HALF-YEARLY / MID-YEAR (6 Months Interval) - Checked second
//   if (
//     normalizedCycle.includes("6_MONTH") || 
//     normalizedCycle.includes("HALF") || 
//     normalizedCycle.includes("MID")
//   ) {
//     return [
//       { label: "H1 / First Half (Apr - Sep)", value: "H1", startDate: `${fyYear}-04-01`, endDate: `${fyYear}-09-30` },
//       { label: "H2 / Second Half (Oct - Mar)", value: "H2", startDate: `${fyYear}-10-01`, endDate: `${fyYear + 1}-03-31` }
//     ];
//   }

//   // 3. QUARTERLY (3 Months Interval) - Checked third
//   if (
//     normalizedCycle.includes("QUARTER") || 
//     normalizedCycle.includes("Q1") || 
//     normalizedCycle.includes("3_MONTH")
//   ) {
//     return [
//       { label: "Q1 (Apr - Jun)", value: "Q1", startDate: `${fyYear}-04-01`, endDate: `${fyYear}-06-30` },
//       { label: "Q2 (Jul - Sep)", value: "Q2", startDate: `${fyYear}-07-01`, endDate: `${fyYear}-09-30` },
//       { label: "Q3 (Oct - Dec)", value: "Q3", startDate: `${fyYear}-10-01`, endDate: `${fyYear}-12-31` },
//       { label: "Q4 (Jan - Mar)", value: "Q4", startDate: `${fyYear + 1}-01-01`, endDate: `${fyYear + 1}-03-31` }
//     ];
//   }

//   // 4. MONTHLY (1 Month Interval starting from April) - Checked last
//   if (normalizedCycle.includes("MONTH") || normalizedCycle.includes("1_MONTH")) {
//     const months = [
//       { name: "April", num: 4, yrOffset: 0 },
//       { name: "May", num: 5, yrOffset: 0 },
//       { name: "June", num: 6, yrOffset: 0 },
//       { name: "July", num: 7, yrOffset: 0 },
//       { name: "August", num: 8, yrOffset: 0 },
//       { name: "September", num: 9, yrOffset: 0 },
//       { name: "October", num: 10, yrOffset: 0 },
//       { name: "November", num: 11, yrOffset: 0 },
//       { name: "December", num: 12, yrOffset: 0 },
//       { name: "January", num: 1, yrOffset: 1 },
//       { name: "February", num: 2, yrOffset: 1 },
//       { name: "March", num: 3, yrOffset: 1 }
//     ];

//     return months.map(m => {
//       const currentYr = fyYear + m.yrOffset;
//       const lastDay = getLastDayOfMonth(currentYr, m.num);
//       return {
//         label: `${m.name} (${fyYear}-${String(fyYear + 1).slice(-2)})`,
//         value: m.name.toUpperCase(),
//         startDate: `${currentYr}-${pad(m.num)}-01`,
//         endDate: `${currentYr}-${pad(m.num)}-${pad(lastDay)}`
//       };
//     });
//   }

//   // Fallback default (Annual)
//   return [
//     { label: "Annual (Apr - Mar)", value: "ANNUAL", startDate: `${fyYear}-04-01`, endDate: `${fyYear + 1}-03-31` }
//   ];
// };

// export default function KraAssignmentsList() {
//   const [loading, setLoading] = useState(true);
//   const [assignments, setAssignments] = useState([]);
//   const [selectedAssignment, setSelectedAssignment] = useState(null); 

//   // Filter dependencies lists
//   const [departments, setDepartments] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [employees, setEmployees] = useState([]);

//   // Selected Filter States
//   const [selectedDepartment, setSelectedDepartment] = useState("");
//   const [selectedDivision, setSelectedDivision] = useState("");
//   const [selectedEmployee, setSelectedEmployee] = useState("");

//   // Table Selected Rows state for Bulk Actions
//   const [selectedRowIds, setSelectedRowIds] = useState([]);

//   // Review Initiate Modals States (Single, Bulk and Cron)
//   const [showReviewModal, setShowReviewModal] = useState(false);
//   const [showBulkModal, setShowBulkModal] = useState(false);
//   const [showCronModal, setShowCronModal] = useState(false);
//   const [submittingReview, setSubmittingReview] = useState(false);

//   // Delete Offcanvas States
//   const [isDeleteOpen, setIsDeleteOpen] = useState(false);
//   const [itemToDelete, setItemToDelete] = useState(null);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const [deleteError, setDeleteError] = useState(null);

//   // Modal Form State (Single)
//   const [reviewForm, setReviewForm] = useState({
//     userId: "",
//     employeeName: "",
//     year: "",
//     cycleType: "",
//     period: "",
//     startDate: "",
//     endDate: "",
//     periodsList: [] 
//   });

//   // Modal Form State (Bulk)
//   const [bulkForm, setBulkForm] = useState({
//     year: new Date().getFullYear(),
//     cycleType: "3_MONTHS",
//     period: "Q1",
//     startDate: `${new Date().getFullYear()}-04-01`,
//     endDate: `${new Date().getFullYear()}-06-30`,
//     periodsList: getAvailablePeriods("3_MONTHS", new Date().getFullYear())
//   });

//   // Modal Form State (Cron Automation)
//   const [cronForm, setCronForm] = useState({
//     year: new Date().getFullYear(),
//     cycleType: "3_MONTHS",
//     period: "Q1",
//     startDate: `${new Date().getFullYear()}-04-01`,
//     endDate: `${new Date().getFullYear()}-06-30`,
//     periodsList: getAvailablePeriods("3_MONTHS", new Date().getFullYear())
//   });

//   const handleOpenReviewModal = useCallback((row) => {
//     const user = row.userId || {};
//     const year = Number(row.year) || new Date().getFullYear();
//     const cycleType = row.reviewCycle || "QUARTERLY"; 

//     const dynamicPeriods = getAvailablePeriods(cycleType, year);
//     const defaultPeriod = dynamicPeriods[0] || {};

//     setReviewForm({
//       userId: user._id || user.id || "",
//       employeeName: `${user.firstName || ""} ${user.lastName || ""}`,
//       year: year,
//       cycleType: cycleType,
//       period: defaultPeriod.value || "",
//       startDate: defaultPeriod.startDate || "",
//       endDate: defaultPeriod.endDate || "",
//       periodsList: dynamicPeriods 
//     });
//     setShowReviewModal(true);
//   }, []);

//   // Filter States
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedCycle, setSelectedCycle] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   const loadAssignmentsAndFilters = useCallback(async () => {
//     setLoading(true);
//     try {
//       const url = SummaryApi.listKraAssignments?.url || "/api/hr/kra/assignments/view-all";
//       const employeesEndpoint = SummaryApi.getAllUsers?.url || "/api/hr/employees/active-list";
      
//       const [assignRes, deptRes, divRes, empRes] = await Promise.all([
//         api.get(url),
//         api.get(SummaryApi.getAllDepartments.url),
//         api.get(SummaryApi.getAllDivisions.url),
//         api.get(employeesEndpoint)
//       ]);

//       if (assignRes.data.success) setAssignments(assignRes.data.data || []);
//       if (deptRes.data.success) setDepartments(deptRes.data.data.map(d => ({ label: d.name, value: d._id })));
//       if (divRes.data.success) setDivisions(divRes.data.data.map(d => ({ label: d.name, value: d._id })));
//       if (empRes.data.success) setEmployees(empRes.data.data.map(e => ({ label: `${e.firstName} ${e.lastName}`, value: e._id })));
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to load active structures.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadAssignmentsAndFilters();
//   }, [loadAssignmentsAndFilters]);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchQuery, selectedCycle, selectedStatus, selectedDepartment, selectedDivision, selectedEmployee]);

//   // Dynamic Metadata for Cycles Filter
//   const cycles = useMemo(() => {
//     const list = assignments.map(a => a.reviewCycle).filter(Boolean);
//     return [
//       ...new Set(list)
//     ].map(item => typeof item === "string" ? { label: item.replace("_", " "), value: item } : item);
//   }, [assignments]);

//   // Dynamic Stats Calculations
//   const stats = useMemo(() => {
//     const totalCount = assignments.length;
//     const acknowledgedCount = assignments.filter(a => a.employeeStatus === "ACKNOWLEDGED").length;
//     const pendingCount = assignments.filter(a => a.employeeStatus === "PENDING_ACKNOWLEDGEMENT").length;
    
//     const totalKras = assignments.reduce((sum, a) => sum + (a.kras?.length || 0), 0);
//     const avgKras = totalCount > 0 ? (totalKras / totalCount).toFixed(1) : "0.0";

//     return { totalCount, acknowledgedCount, pendingCount, avgKras };
//   }, [assignments]);

//   // Front-end Filtering Logic with enhanced parameters
//   const filteredAssignments = useMemo(() => {
//     return assignments.filter(a => {
//       const user = a.userId || {};
//       const fullName = `${user.firstName || ""} ${user.lastName || ""}`.toLowerCase();
      
//       const matchesSearch = fullName.includes(searchQuery.toLowerCase()) || 
//                             (user.userId && user.userId.toLowerCase().includes(searchQuery.toLowerCase()));

//       const matchesCycle = !selectedCycle || a.reviewCycle === selectedCycle;
//       const matchesStatus = !selectedStatus || a.employeeStatus === selectedStatus;

//       // Safe matching for designation, division and department objects
//       const uDeptId = user.departmentId?._id || user.departmentId;
//       const uDivId = user.divisionId?._id || user.divisionId;

//       const matchesDepartment = !selectedDepartment || uDeptId === selectedDepartment;
//       const matchesDivision = !selectedDivision || uDivId === selectedDivision;
//       const matchesEmployee = !selectedEmployee || user._id === selectedEmployee;

//       return matchesSearch && matchesCycle && matchesStatus && matchesDepartment && matchesDivision && matchesEmployee;
//     });
//   }, [assignments, searchQuery, selectedCycle, selectedStatus, selectedDepartment, selectedDivision, selectedEmployee]);

//   // Front-end Pagination
//   const paginatedAssignments = useMemo(() => {
//     const startIdx = (currentPage - 1) * itemsPerPage;
//     return filteredAssignments.slice(startIdx, startIdx + itemsPerPage);
//   }, [filteredAssignments, currentPage]);

//   // Submit appraisal sheet for a single selected employee
//   const handleInitiateReviewSubmit = async (e) => {
//     e.preventDefault();
//     setSubmittingReview(true);
//     try {
//       const payload = {
//         userId: reviewForm.userId,
//         year: Number(reviewForm.year),
//         period: reviewForm.period,
//         startDate: new Date(reviewForm.startDate).toISOString(),
//         endDate: new Date(reviewForm.endDate).toISOString()
//       };

//       const url = SummaryApi.reviewInitiateKra?.url || "/api/hr/kra/appraisals/initiate";
//       const method = SummaryApi.reviewInitiateKra?.method || "post";

//       const res = await api({
//         url,
//         method,
//         data: payload
//       });

//       if (res.data.success) {
//         toast.success(res.data.message || "Review initiated successfully!");
//         setShowReviewModal(false);
//       } else {
//         toast.error(res.data.message || "Failed to initiate review.");
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Error initiating review process.");
//     } finally {
//       setSubmittingReview(false);
//     }
//   };

//   // Submit bulk appraisal sheet for checked employees
//   const handleBulkInitiateSubmit = async (e) => {
//     e.preventDefault();
//     setSubmittingReview(true);
//     try {
//       const selectedAssignments = assignments.filter(a => selectedRowIds.includes(a._id));
//       const userIds = selectedAssignments.map(a => a.userId?._id || a.userId).filter(Boolean);

//       if (userIds.length === 0) {
//         return toast.error("No valid employees selected.");
//       }

//       const payload = {
//         userIds,
//         year: Number(bulkForm.year),
//         period: bulkForm.period,
//         startDate: new Date(bulkForm.startDate).toISOString(),
//         endDate: new Date(bulkForm.endDate).toISOString()
//       };

//       const res = await api.post(SummaryApi.bulkReviewInitiateKra?.url || "/api/hr/kra/appraisals/bulk-initiate", payload);
//       if (res.data.success) {
//         const { processed, errors } = res.data.data;
//         toast.success(`Appraisals initiated for ${processed.length} employees.`);
//         if (errors && errors.length > 0) {
//           toast.warning(`${errors.length} sheets skipped due to duplicate initiation rules.`);
//         }
//         setShowBulkModal(false);
//         setSelectedRowIds([]); // Reset checklist
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Bulk initiation failed.");
//     } finally {
//       setSubmittingReview(false);
//     }
//   };

//   // Trigger Cron automation for KRA review initiation
//   const handleCronInitiateSubmit = async (e) => {
//     e.preventDefault();
//     setSubmittingReview(true);
//     try {
//       const payload = {
//         year: Number(cronForm.year),
//         period: cronForm.period,
//         startDate: new Date(cronForm.startDate).toISOString(),
//         endDate: new Date(cronForm.endDate).toISOString()
//       };

//       const res = await api.post(SummaryApi.autoInitiateReviews.url, payload);
//       if (res.data.success) {
//         const { totalProcessed, errors } = res.data.data;
//         toast.success(`Automation Complete! Generated ${totalProcessed} appraisal review sheets.`);
//         if (errors && errors.length > 0) {
//           toast.warning(`${errors.length} sheets skipped.`);
//         }
//         setShowCronModal(false);
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Cron simulation process failed.");
//     } finally {
//       setSubmittingReview(false);
//     }
//   };

//   // Delete Action Click handler (Enforces logic before opening Offcanvas)
//   const handleDeleteClick = (row) => {
//     if (row.employeeStatus === "ACKNOWLEDGED") {
//       return toast.warning("This assignment has already been acknowledged by the employee and cannot be deleted.");
//     }
//     setItemToDelete(row);
//     setDeleteError(null);
//     setIsDeleteOpen(true);
//   };

//   // Final delete submission call
//   const handleConfirmDelete = async () => {
//     if (!itemToDelete) return;
//     setIsDeleting(true);
//     setDeleteError(null);
//     try {
//       const url = SummaryApi.deleteEmployeeKras.url(itemToDelete._id);
//       await api.delete(url);
//       toast.success("Successfully deleted KRA assignment.");
//       setAssignments(p => p.filter(a => a._id !== itemToDelete._id));
//       setIsDeleteOpen(false);
//       setItemToDelete(null);
//     } catch (err) {
//       const errMsg = err.response?.data?.message || "Deletion failed.";
//       setDeleteError({ message: errMsg, users: [] });
//       toast.error(errMsg);
//     } finally {
//       setIsDeleting(false);
//     }
//   };

//   const resetAllFilters = () => {
//     setSelectedDepartment("");
//     setSelectedDivision("");
//     setSelectedEmployee("");
//     setSelectedCycle("");
//     setSelectedStatus("");
//     setSearchQuery("");
//   };

//   const columns = useMemo(() => [
//     {
//       key: "employee",
//       label: "Employee",
//       render: (row) => {
//         const user = row.userId || {};
//         return (
//           <div className="flex items-center gap-3">
//             {user.profilePicture ? (
//               <img src={user.profilePicture} alt="" className="w-8 h-8 rounded-full object-cover shrink-0" />
//             ) : (
//               <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center text-red-600 text-[10px] font-bold shrink-0">
//                 {user.firstName?.[0] || ""}{user.lastName?.[0] || ""}
//               </div>
//             )}
//             <div>
//               <p className="font-bold text-slate-900 whitespace-nowrap">{user.firstName} {user.lastName}</p>
//               <p className="text-[10px] text-slate-400 font-medium whitespace-nowrap">{user.email}</p>
//             </div>
//           </div>
//         );
//       }
//     },
//     {
//       key: "employeeId",
//       label: "Employee ID",
//       render: (row) => {
//         const user = row.userId || {};
//         return <span className="font-semibold text-slate-500">{user.userId || "EMP-N/A"}</span>;
//       }
//     },
//     {
//       key: "year",
//       label: "Year",
//       render: (row) => <span className="text-slate-500">FY {row.year}</span>
//     },
//     {
//       key: "workflow",
//       label: "Workflow Configuration",
//       render: (row) => {
//         const workflow = row.workflowId || {};
//         return <span className="text-slate-500 font-medium">{workflow.name || "Default KRA Stage Flow"}</span>;
//       }
//     },
//     {
//       key: "goals",
//       label: "Assigned Goals",
//       headerAlign: "center",
//       render: (row) => {
//         const kraCount = row.kras?.length || 0;
//         return (
//           <span className="bg-slate-100 text-slate-700 border font-bold px-2.5 py-0.5 rounded-full text-[10px]">
//             {kraCount} Goals Assigned
//           </span>
//         );
//       }
//     },
//     {
//       key: "reviewCycle",
//       label: "Review Cycle",
//       render: (row) => (
//         <span className="text-slate-500 uppercase tracking-wider text-[10px] font-bold">
//           {row.reviewCycle?.replace("_", " ")}
//         </span>
//       )
//     },
//     {
//       key: "status",
//       label: "Ack Status",
//       render: (row) => (
//         <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border uppercase tracking-wider ${
//           row.employeeStatus === "ACKNOWLEDGED" 
//             ? "bg-green-50 text-green-700 border-green-200" 
//             : row.employeeStatus === "PENDING_ACKNOWLEDGEMENT"
//             ? "bg-amber-50 text-amber-700 border-amber-200"
//             : "bg-red-50 text-red-700 border-red-200"
//         }`}>
//           {row.employeeStatus?.replace("_", " ")}
//         </span>
//       )
//     }
//   ], []);

//   // Conditional Actions rendering
//   const tableActions = useMemo(() => [
//     {
//       label: "View KRAs",
//       icon: <Eye className="w-4 h-4 text-slate-500" />,
//       onClick: (row) => setSelectedAssignment(row)
//     },
//     {
//       label: "Initiate Review",
//       icon: <Play className="w-4 h-4 text-emerald-500" />,
//       onClick: (row) => handleOpenReviewModal(row),
//       show: (row) => row.employeeStatus === "ACKNOWLEDGED",
//     },
//     {
//       label: "Delete Assignment",
//       icon: <Trash2 className="w-4 h-4 text-red-500" />,
//       onClick: (row) => handleDeleteClick(row),
//       show: (row) => row.employeeStatus !== "ACKNOWLEDGED",
//     }
//   ], [handleOpenReviewModal]);

//   if (loading) return <PageLoader />;

//   return (
//     <>

//     <div className="space-y-4 animate-in fade-in duration-300">
      
//       {/* HEADER CONTROLS WITH REVIEWS BULK & CRON TRIGGERS */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//         <div className="text-left">
//           <h1 className="text-lg md:text-xl font-bold text-slate-900 tracking-tight">KRA Goal Assignments</h1>
//           <p className="text-xs text-slate-400 mt-1">Review assigned goals, categories, and weightages before initiating appraisals.</p>
//         </div>

//         {/* Global Action buttons for bulk & auto reviews initiation */}
//         <div className="flex items-center gap-3 self-end sm:self-auto">
//           {selectedRowIds.length > 0 && (
//             <button 
//               onClick={() => setShowBulkModal(true)}
//               className="flex items-center gap-1.5 bg-primary hover:bg-secondary text-white px-4 py-2 rounded-lg font-bold text-xs uppercase hover:shadow-lg transition-all"
//             >
//               <Play className="w-4 h-4" /> Bulk Initiate Appraisal ({selectedRowIds.length})
//             </button>
//           )}

//           <button 
//             onClick={() => setShowCronModal(true)}
//             className="flex items-center gap-1.5 bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-lg font-bold text-xs uppercase hover:shadow-lg transition-all"
//           >
//             <Cpu className="w-4 h-4" /> Run Auto-Cron
//           </button>
//         </div>
//       </div>

//       {/* STATS ROW */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
//         <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
//           <div className="w-12 h-12 bg-blue-50 border border-blue-100 rounded-full flex items-center justify-center text-blue-600 shrink-0">
//             <Users className="w-5 h-5" />
//           </div>
//           <div className="text-left">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Total Assignments</span>
//             <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.totalCount}</p>
//             <span className="text-[10px] text-slate-400 font-semibold">Active employees KRA</span>
//           </div>
//         </div>

//         <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
//           <div className="w-12 h-12 bg-green-50 border border-green-100 rounded-full flex items-center justify-center text-green-600 shrink-0">
//             <CheckCircle2 className="w-5 h-5" />
//           </div>
//           <div className="text-left">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Acknowledged</span>
//             <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.acknowledgedCount}</p>
//             <span className="text-[10px] text-green-600 font-semibold">Accepted by employees</span>
//           </div>
//         </div>

//         <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
//           <div className="w-12 h-12 bg-amber-50 border border-amber-100 rounded-full flex items-center justify-center text-amber-600 shrink-0">
//             <Clock className="w-5 h-5" />
//           </div>
//           <div className="text-left">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Pending Acceptance</span>
//             <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.pendingCount}</p>
//             <span className="text-[10px] text-amber-600 font-semibold">Waiting for action</span>
//           </div>
//         </div>

//         <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
//           <div className="w-12 h-12 bg-pink-50 border border-pink-100 rounded-full flex items-center justify-center text-pink-500 shrink-0">
//             <Layers className="w-5 h-5" />
//           </div>
//           <div className="text-left">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Average KRAs</span>
//             <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.avgKras}</p>
//             <span className="text-[10px] text-slate-400 font-semibold">Goals per employee</span>
//           </div>
//         </div>
//       </div>

//       {/* FILTER SEARCH PANEL WITH ADVANCED CATEGORY DROPDOWNS */}
//       <div className="bg-white border rounded-xl p-5 shadow-sm space-y-4">
//         <div className="flex flex-wrap items-center gap-4">
//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Review Cycle</span>
//             <SelectDropdown options={cycles} value={selectedCycle} onChange={setSelectedCycle} placeholder="All Cycles" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
//           </div>

//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Ack Status</span>
//             <SelectDropdown options={[{ label: "Acknowledged", value: "ACKNOWLEDGED" }, { label: "Pending", value: "PENDING_ACKNOWLEDGEMENT" }, { label: "Disputed", value: "DISPUTED" }]} value={selectedStatus} onChange={setSelectedStatus} placeholder="All Status" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
//           </div>

//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Division</span>
//             <SelectDropdown options={divisions} value={selectedDivision} onChange={setSelectedDivision} placeholder="All Divisions" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
//           </div>

//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Department</span>
//             <SelectDropdown options={departments} value={selectedDepartment} onChange={setSelectedDepartment} placeholder="All Departments" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
//           </div>

//           <div className="w-48">
//             <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Employee Selection</span>
//             <SelectDropdown options={employees} value={selectedEmployee} onChange={setSelectedEmployee} placeholder="All Employees" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
//           </div>

//           <button type="button" onClick={resetAllFilters} className="flex items-center gap-1.5 px-4 py-2 border rounded-lg text-xs font-semibold h-9 mt-5 border-slate-200 hover:bg-slate-50 transition-colors">
//             <X className="h-4 w-4" /> Reset Filters
//           </button>
//         </div>

//         {/* Global Local Search Panel */}
//         <div className="relative pt-1">
//           <Search className="w-4 h-4 text-slate-400 absolute left-3 top-3.5" />
//           <input 
//             type="text" 
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             placeholder="Search employees dynamically by name or ID..."
//             className="w-full border border-slate-200 rounded-lg pl-9 pr-4 py-1.5 text-xs outline-none focus:ring-1 focus:ring-red-200 h-9"
//           />
//         </div>
//       </div>

//       {/* MODERN TABLE (Checkbox bulk selection enabled) */}
//       <div className="">
//         <div className="pb-4 flex justify-between items-center">
//           <span className="font-bold text-slate-800 text-lg">Employee Goal Setup ({filteredAssignments.length})</span>
//         </div>

//         <ModernTable 
//           columns={columns}
//           data={paginatedAssignments}
//           actions={tableActions}
//           actionType="dropdown" 
//           selectable={true} // Checkbox selection active
//           selectedRows={selectedRowIds} // Sync checked ids
//           onSelectionChange={setSelectedRowIds} // Sync checked ids
//           stickyColumns={1}
//           isRowSelectable={(row) => row.employeeStatus === "ACKNOWLEDGED"} 
//           pagination={{
//             totalItems: filteredAssignments.length,
//             itemsPerPage: itemsPerPage,
//             currentPage: currentPage,
//             onPageChange: setCurrentPage
//           }}
//         />
//       </div>
//      </div>
    
//       {/* INITIATE REVIEW MODAL (SINGLE) */}
//       {showReviewModal && (
//         <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
//           <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl border flex flex-col max-h-[90vh] sm:max-h-[85vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            
//             <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
//               <div className="flex gap-3 items-center">
//                 <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0 border border-emerald-100">
//                   <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
//                 </div>
//                 <div className="text-left">
//                   <h3 className="font-bold text-gray-900 text-xs sm:text-base leading-tight">
//                     Initiate KRA Appraisal
//                   </h3>
//                   <p className="text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mt-0.5">
//                     Review Cycle Initiation Setup
//                   </p>
//                 </div>
//               </div>
//               <button 
//                 onClick={() => setShowReviewModal(false)}
//                 className="p-1 sm:p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg transition-colors border"
//               >
//                 <X className="w-4 h-4" />
//               </button>
//             </div>

//             <form onSubmit={handleInitiateReviewSubmit} className="flex flex-col flex-1 overflow-hidden">
//               <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar">
//                 <div className="text-left">
//                   <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Employee</label>
//                   <input 
//                     type="text" 
//                     readOnly 
//                     disabled
//                     value={reviewForm.employeeName}
//                     className="w-full border rounded-lg px-3 py-2 text-xs bg-slate-50 text-slate-500 font-semibold border-slate-200 focus:outline-none"
//                   />
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Year</label>
//                     <input 
//                       type="text" 
//                       readOnly 
//                       disabled
//                       value={`FY ${reviewForm.year}`}
//                       className="w-full border rounded-lg px-3 py-2 text-xs bg-slate-50 text-slate-500 font-semibold border-slate-200 focus:outline-none"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Period</label>
//                     <select
//                       value={reviewForm.period}
//                       onChange={(e) => {
//                         const selectedVal = e.target.value;
//                         const match = reviewForm.periodsList.find(p => p.value === selectedVal);
//                         if (match) {
//                           setReviewForm(prev => ({
//                             ...prev,
//                             period: selectedVal,
//                             startDate: match.startDate,
//                             endDate: match.endDate
//                           }));
//                         }
//                       }}
//                       className="w-full border rounded-lg px-3 py-2 text-xs font-semibold border-slate-200 text-slate-700 bg-white focus:outline-none focus:ring-1 focus:ring-red-200"
//                     >
//                       {reviewForm.periodsList.map((p) => (
//                         <option key={p.value} value={p.value}>
//                           {p.label}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Start Date</label>
//                     <input 
//                       type="date"
//                       required
//                       value={reviewForm.startDate}
//                       onChange={(e) => setReviewForm(prev => ({ ...prev, startDate: e.target.value }))}
//                       className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">End Date</label>
//                     <input 
//                       type="date"
//                       required
//                       value={reviewForm.endDate}
//                       onChange={(e) => setReviewForm(prev => ({ ...prev, endDate: e.target.value }))}
//                       className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
//                 <button
//                   type="button"
//                   onClick={() => setShowReviewModal(false)}
//                   className="px-3 py-2 sm:px-4 bg-white hover:bg-slate-50 text-slate-700 border rounded-lg text-[10px] sm:text-xs font-bold uppercase transition-colors"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={submittingReview}
//                   className="px-3 py-2 sm:px-4 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-[10px] sm:text-xs font-bold uppercase transition-colors disabled:opacity-50"
//                 >
//                   {submittingReview ? "Initiating..." : "Initiate Review"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* ✅ Added: BULK REVIEW INITIATION MODAL (Dynamic Frequency Selection) */}
//       {showBulkModal && (
//         <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
//           <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl border flex flex-col max-h-[90vh] sm:max-h-[85vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
//             <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
//               <div className="flex gap-3 items-center">
//                 <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-blue-50 text-primary flex items-center justify-center shrink-0 border border-blue-100">
//                   <Play className="w-4 h-4 sm:w-5 sm:h-5" />
//                 </div>
//                 <div className="text-left">
//                   <h3 className="font-bold text-gray-900 text-xs sm:text-base leading-tight">Bulk Initiate Appraisal</h3>
//                   <p className="text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mt-0.5">Bulk Setup for {selectedRowIds.length} members</p>
//                 </div>
//               </div>
//               <button onClick={() => setShowBulkModal(false)} className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg transition-colors border">
//                 <X className="w-4 h-4" />
//               </button>
//             </div>

//             <form onSubmit={handleBulkInitiateSubmit} className="flex flex-col flex-1 overflow-hidden">
//               <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar">
                
//                 {/* Dynamically selectable review frequency inside Bulk Modal */}
//                 <div className="text-left">
//                   <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Review Frequency</label>
//                   <select
//                     value={bulkForm.cycleType || "3_MONTHS"}
//                     onChange={(e) => {
//                       const selectedCycle = e.target.value;
//                       const dynamicPeriods = getAvailablePeriods(selectedCycle, bulkForm.year);
//                       const defaultPeriod = dynamicPeriods[0] || {};
//                       setBulkForm(p => ({
//                         ...p,
//                         cycleType: selectedCycle,
//                         period: defaultPeriod.value || "",
//                         startDate: defaultPeriod.startDate || "",
//                         endDate: defaultPeriod.endDate || "",
//                         periodsList: dynamicPeriods
//                       }));
//                     }}
//                     className="w-full border border-slate-200 rounded-lg px-3 py-2 text-xs font-semibold text-slate-700 bg-white focus:outline-none focus:ring-1 focus:ring-red-200 h-9"
//                   >
//                     <option value="1_MONTH">Monthly</option>
//                     <option value="3_MONTHS">Quarterly</option>
//                     <option value="6_MONTHS">Half-Yearly</option>
//                     <option value="12_MONTHS">Annual</option>
//                   </select>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Financial Year</label>
//                     <input 
//                       type="number" 
//                       value={bulkForm.year} 
//                       onChange={(e) => {
//                         const yr = Number(e.target.value) || new Date().getFullYear();
//                         setBulkForm(p => ({ ...p, year: yr, periodsList: getAvailablePeriods(p.cycleType || "3_MONTHS", yr) }));
//                       }} 
//                       className="w-full border rounded-lg px-3 py-2 text-xs text-slate-700 font-semibold focus:outline-none focus:ring-1 focus:ring-red-200" 
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Review Period</label>
//                     <select
//                       value={bulkForm.period}
//                       onChange={(e) => {
//                         const selectedVal = e.target.value;
//                         const match = bulkForm.periodsList.find(p => p.value === selectedVal);
//                         if (match) {
//                           setBulkForm(p => ({ ...p, period: selectedVal, startDate: match.startDate, endDate: match.endDate }));
//                         }
//                       }}
//                       className="w-full border rounded-lg px-3 py-2 text-xs font-semibold border-slate-200 text-slate-700 bg-white focus:outline-none focus:ring-1 focus:ring-red-200"
//                     >
//                       {bulkForm.periodsList.map((p) => (
//                         <option key={p.value} value={p.value}>{p.label}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Start Date</label>
//                     <input type="date" required value={bulkForm.startDate} onChange={(e) => setBulkForm(p => ({ ...p, startDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none" />
//                   </div>
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">End Date</label>
//                     <input type="date" required value={bulkForm.endDate} onChange={(e) => setBulkForm(p => ({ ...p, endDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none" />
//                   </div>
//                 </div>
//               </div>

//               <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
//                 <button type="button" onClick={() => setShowBulkModal(false)} className="px-4 py-2 bg-white text-slate-700 border rounded-lg text-xs font-bold uppercase">Cancel</button>
//                 <button type="submit" disabled={submittingReview} className="px-4 py-2 bg-primary text-white rounded-lg text-xs font-bold uppercase disabled:opacity-50">
//                   {submittingReview ? "Initiating Bulk..." : "Bulk Initiate"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* ✅ Added: RUN AUTO-CRON SIMULATION MODAL (Dynamic Frequency Selection) */}
//       {showCronModal && (
//         <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
//           <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl border flex flex-col max-h-[90vh] sm:max-h-[85vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
//             <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
//               <div className="flex gap-3 items-center">
//                 <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center shrink-0 border border-amber-100">
//                   <Cpu className="w-4 h-4 sm:w-5 sm:h-5" />
//                 </div>
//                 <div className="text-left">
//                   <h3 className="font-bold text-gray-900 text-xs sm:text-base leading-tight">Auto-Cron Appraisal Simulation</h3>
//                   <p className="text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mt-0.5">Automates review sheets for all active profiles</p>
//                 </div>
//               </div>
//               <button onClick={() => setShowCronModal(false)} className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg transition-colors border">
//                 <X className="w-4 h-4" />
//               </button>
//             </div>

//             <form onSubmit={handleCronInitiateSubmit} className="flex flex-col flex-1 overflow-hidden">
//               <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar">
                
//                 {/* Dynamically selectable review frequency inside Cron Modal */}
//                 <div className="text-left">
//                   <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Review Frequency</label>
//                   <select
//                     value={cronForm.cycleType || "3_MONTHS"}
//                     onChange={(e) => {
//                       const selectedCycle = e.target.value;
//                       const dynamicPeriods = getAvailablePeriods(selectedCycle, cronForm.year);
//                       const defaultPeriod = dynamicPeriods[0] || {};
//                       setCronForm(p => ({
//                         ...p,
//                         cycleType: selectedCycle,
//                         period: defaultPeriod.value || "",
//                         startDate: defaultPeriod.startDate || "",
//                         endDate: defaultPeriod.endDate || "",
//                         periodsList: dynamicPeriods
//                       }));
//                     }}
//                     className="w-full border border-slate-200 rounded-lg px-3 py-2 text-xs font-semibold text-slate-700 bg-white focus:outline-none focus:ring-1 focus:ring-red-200 h-9"
//                   >
//                     <option value="1_MONTH">Monthly</option>
//                     <option value="3_MONTHS">Quarterly</option>
//                     <option value="6_MONTHS">Half-Yearly</option>
//                     <option value="12_MONTHS">Annual</option>
//                   </select>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Financial Year</label>
//                     <input 
//                       type="number" 
//                       value={cronForm.year} 
//                       onChange={(e) => {
//                         const yr = Number(e.target.value) || new Date().getFullYear();
//                         setCronForm(p => ({ ...p, year: yr, periodsList: getAvailablePeriods(p.cycleType || "3_MONTHS", yr) }));
//                       }} 
//                       className="w-full border rounded-lg px-3 py-2 text-xs text-slate-700 font-semibold focus:outline-none focus:ring-1 focus:ring-red-200" 
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Review Period</label>
//                     <select
//                       value={cronForm.period}
//                       onChange={(e) => {
//                         const selectedVal = e.target.value;
//                         const match = cronForm.periodsList.find(p => p.value === selectedVal);
//                         if (match) {
//                           setCronForm(p => ({ ...p, period: selectedVal, startDate: match.startDate, endDate: match.endDate }));
//                         }
//                       }}
//                       className="w-full border rounded-lg px-3 py-2 text-xs font-semibold border-slate-200 text-slate-700 bg-white focus:outline-none"
//                     >
//                       {cronForm.periodsList.map((p) => (
//                         <option key={p.value} value={p.value}>{p.label}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Start Date</label>
//                     <input type="date" required value={cronForm.startDate} onChange={(e) => setCronForm(p => ({ ...p, startDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none" />
//                   </div>
//                   <div>
//                     <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">End Date</label>
//                     <input type="date" required value={cronForm.endDate} onChange={(e) => setCronForm(p => ({ ...p, endDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none" />
//                   </div>
//                 </div>
//               </div>

//               <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
//                 <button type="button" onClick={() => setShowCronModal(false)} className="px-4 py-2 bg-white text-slate-700 border rounded-lg text-xs font-bold uppercase">Cancel</button>
//                 <button type="submit" disabled={submittingReview} className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-xs font-bold uppercase disabled:opacity-50">
//                   {submittingReview ? "Executing Cron..." : "Trigger Auto-Cron"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* DETAIL WORKSPACE OVERLAY (MODAL VIEW FOR INDIVIDUAL KRAs) */}
//       {selectedAssignment && (
//         <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
//           <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl border overflow-hidden flex flex-col max-h-[85vh] animate-in fade-in zoom-in-95 duration-200">
            
//             {/* Modal Header */}
//             <div className="p-5 border-b flex justify-between items-start gap-4">
//               <div className="flex gap-3 items-center">
//                 <div className="w-10 h-10 rounded-full bg-red-50 text-primary flex items-center justify-center shrink-0 border border-red-100">
//                   <Award className="w-5 h-5" />
//                 </div>
//                 <div className="text-left">
//                   <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-tight">
//                     {selectedAssignment.userId?.firstName} {selectedAssignment.userId?.lastName} - Goal Setup Details
//                   </h3>
//                   <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">
//                     FY {selectedAssignment.year} • {selectedAssignment.reviewCycle?.replace("_", " ")} Setup
//                   </p>
//                 </div>
//               </div>
//               <button 
//                 onClick={() => setSelectedAssignment(null)}
//                 className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-primary rounded-lg transition-colors border"
//               >
//                 <X className="w-4 h-4" />
//               </button>
//             </div>

//             {/* Modal Body with FULL details populated dynamically */}
//             <div className="p-6 overflow-y-auto space-y-4 custom-scrollbar flex-1 bg-slate-50/40 text-left">
              
//               <div className="bg-white border rounded-xl p-4 shadow-sm grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs">
//                 <div>
//                   <span className="block text-[10px] text-gray-400 font-bold uppercase">Department</span>
//                   <span className="font-bold text-gray-800">{selectedAssignment.userId?.departmentId?.name || "N/A"}</span>
//                 </div>
//                 <div>
//                   <span className="block text-[10px] text-gray-400 font-bold uppercase">Designation</span>
//                   <span className="font-bold text-gray-800">
//                     {selectedAssignment.userId?.designationId?.title || selectedAssignment.userId?.designationId?.name || "N/A"}
//                   </span>
//                 </div>
//                 <div>
//                   <span className="block text-[10px] text-gray-400 font-bold uppercase">Cycle Timeline Bounds</span>
//                   <span className="font-bold text-gray-800">
//                     {formatDateTime(selectedAssignment.startDate, false)} to {formatDateTime(selectedAssignment.endDate, false)}
//                   </span>
//                 </div>
//                 <div>
//                   <span className="block text-[10px] text-gray-400 font-bold uppercase">Allocated By</span>
//                   <span className="font-bold text-gray-800">
//                     {selectedAssignment.assignedBy?.firstName} {selectedAssignment.assignedBy?.lastName || "HR System Administrator"}
//                   </span>
//                 </div>
//                 <div>
//                   <span className="block text-[10px] text-gray-400 font-bold uppercase">Workflow assigned</span>
//                   <span className="font-bold text-gray-800">{selectedAssignment.workflowId?.name || "Standard Workflow"}</span>
//                 </div>
//                 <div>
//                   <span className="block text-[10px] text-gray-400 font-bold uppercase">Assigned Bundle Reference</span>
//                   <span className="font-bold text-gray-800">{selectedAssignment.bundleId?.name || "Custom/Manual Selection"}</span>
//                 </div>
//               </div>

//               {selectedAssignment.employeeStatus === "ACKNOWLEDGED" && (
//                 <div className="bg-green-50 border border-green-100 rounded-xl p-4 text-xs space-y-1.5 shadow-sm">
//                   <div className="flex justify-between items-center text-green-700 font-bold">
//                     <span className="uppercase text-[9px] tracking-wider">Employee Acknowledged Comment</span>
//                     {selectedAssignment.acknowledgedAt && (
//                       <span className="text-[9px] font-normal">
//                         Date: {formatDateTime(selectedAssignment.acknowledgedAt, false)}
//                       </span>
//                     )}
//                   </div>
//                   <p className="text-green-600 leading-relaxed italic">
//                     "{selectedAssignment.employeeComment || "Accepted without comments."}"
//                   </p>
//                 </div>
//               )}

//               {selectedAssignment.employeeStatus === "DISPUTED" && (
//                 <div className="bg-red-50 border border-red-100 rounded-xl p-4 text-xs space-y-1.5 shadow-sm">
//                   <span className="uppercase text-[9px] tracking-wider text-red-700 font-bold">Employee Dispute Remarks</span>
//                   <p className="text-red-600 leading-relaxed italic">
//                     "{selectedAssignment.employeeComment || "No remarks provided."}"
//                   </p>
//                 </div>
//               )}

//               {/* Enhanced Goal Visualizer showing targets and specific cycles */}
//               <div className="space-y-3">
//                 <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block">Assigned Key Result Areas (KRAs)</span>
                
//                 {selectedAssignment.kras?.map((k, kIdx) => (
//                   <div key={kIdx} className="bg-white border rounded-xl p-4 shadow-sm space-y-3">
//                     <div className="flex justify-between items-start gap-4">
//                       <div className="space-y-1 min-w-0">
//                         <span className="inline-block bg-slate-100 text-slate-700 text-[9px] font-bold px-2 py-0.5 rounded-full uppercase">
//                           {k.category}
//                         </span>
//                         <h4 className="font-bold text-gray-900 text-sm sm:text-base leading-tight truncate">{k.name}</h4>
//                       </div>
//                       <span className="bg-red-50 text-primary border border-red-100 text-[10px] font-bold px-2.5 py-0.5 rounded-lg shrink-0">
//                         Weight: {k.weightage}%
//                       </span>
//                     </div>
//                     <p className="text-xs text-gray-400 leading-relaxed border-t pt-2 mt-1">{k.description || "No description provided."}</p>
                    
//                     {/* Optional targets and dynamic review frequency rendered perfectly inside card */}
//                     <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-2 pt-2.5 border-t border-dashed border-gray-100 text-[11px] text-gray-500">
//                       <div>
//                         <span className="text-[9px] text-gray-400 font-bold uppercase block">Review Frequency</span>
//                         <span className="font-semibold text-gray-700">{k.reviewCycle?.replace("_", " ")}</span>
//                       </div>
//                       <div>
//                         <span className="text-[9px] text-gray-400 font-bold uppercase block">Monthly Target</span>
//                         <span className="font-semibold text-gray-700">{k.monthlyTarget || "N/A"}</span>
//                       </div>
//                       <div>
//                         <span className="text-[9px] text-gray-400 font-bold uppercase block">Yearly Target</span>
//                         <span className="font-semibold text-gray-700">{k.yearlyTarget || "N/A"}</span>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//             </div>

//             <div className="p-4 border-t bg-slate-50 flex justify-end">
//               <button
//                 onClick={() => setSelectedAssignment(null)}
//                 className="px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 border rounded-lg text-xs font-bold uppercase transition-colors"
//               >
//                 Close View
//               </button>
//             </div>

//           </div>
//         </div>
//       )}

//       {/* ✅ Delete Confirmation Offcanvas (Linked perfectly) */}
//       <DeleteConfirmationOffcanvas
//         isOpen={isDeleteOpen}
//         onClose={() => {
//           setIsDeleteOpen(false);
//           setItemToDelete(null);
//           setDeleteError(null);
//         }}
//         onConfirm={handleConfirmDelete}
//         title="Delete KRA Assignment"
//         itemName={itemToDelete ? `${itemToDelete.userId?.firstName} ${itemToDelete.userId?.lastName}'s Assignment` : ""}
//         error={deleteError}
//         isLoading={isDeleting}
//         deleteType="hard"
//         navigateButtonText="Dismiss"
//         onNavigateToUsers={() => {
//           setIsDeleteOpen(false);
//           setItemToDelete(null);
//           setDeleteError(null);
//         }}
//         onViewUser={() => {}}
//       />
//     </>
//   );
// }

import React, { useState, useEffect, useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import { 
  Users, CheckCircle2, Clock, Eye, 
  Award, X, Layers, Search, Calendar, Play, Trash2, Cpu, Edit3, ChevronDown
} from "lucide-react";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import PageLoader from "../../helpers/PageLoader";
import SelectDropdown from "../../customStyles/SelectDropdown";
import ModernTable from "../ui/ModernTable";
import DeleteConfirmationOffcanvas from "../../helpers/DeleteConfirmationOffcanvas";
import { formatDateTime } from "../../helpers/formatDateTime";

// Helper to format system DB cycle keys to user-friendly labels
const formatCycleDisplay = (cycle) => {
  const mapping = {
    "1_WEEK": "Weekly",
    "2_WEEKS": "Bi-weekly",
    "1_MONTH": "Monthly",
    "2_MONTHS": "Bi-monthly",
    "3_MONTHS": "Quarterly",
    "6_MONTHS": "Half-Yearly",
    "12_MONTHS": "Annual"
  };
  return mapping[cycle] || cycle;
};

const formatISO = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const getAvailablePeriods = (reviewCycle, year) => {
  const fyYear = Number(year) || new Date().getFullYear();
  const normalizedCycle = String(reviewCycle).toUpperCase().replace(/\s+/g, "_");

  const getLastDayOfMonth = (yr, month) => {
    return new Date(yr, month, 0).getDate(); 
  };

  const pad = (num) => String(num).padStart(2, '0');

  // 1. WEEKLY (Generates 52 weeks dynamically starting from April 1st)
  if (normalizedCycle.includes("1_WEEK") || normalizedCycle.includes("WEEKLY")) {
    const periods = [];
    let current = new Date(fyYear, 3, 1); 
    const end = new Date(fyYear + 1, 3, 0); 
    let weekNum = 1;
    while (current <= end) {
      const next = new Date(current);
      next.setDate(current.getDate() + 6);
      const actualEnd = next > end ? end : next;
      
      periods.push({
        label: `Week ${weekNum} (${current.toLocaleDateString("en-US", { month: "short", day: "numeric" })} - ${actualEnd.toLocaleDateString("en-US", { month: "short", day: "numeric" })})`,
        value: `WEEK_${weekNum}`,
        startDate: formatISO(current),
        endDate: formatISO(actualEnd)
      });
      current.setDate(current.getDate() + 7);
      weekNum++;
    }
    return periods;
  }

  // 2. BI-WEEKLY (Generates 26 fortnightly periods dynamically starting from April 1st)
  if (normalizedCycle.includes("2_WEEK") || normalizedCycle.includes("BI_WEEK") || normalizedCycle.includes("BIWEEKLY")) {
    const periods = [];
    let current = new Date(fyYear, 3, 1); 
    const end = new Date(fyYear + 1, 3, 0); 
    let fortniteNum = 1;
    while (current <= end) {
      const next = new Date(current);
      next.setDate(current.getDate() + 13);
      const actualEnd = next > end ? end : next;
      
      periods.push({
        label: `Bi-week ${fortniteNum} (${current.toLocaleDateString("en-US", { month: "short", day: "numeric" })} - ${actualEnd.toLocaleDateString("en-US", { month: "short", day: "numeric" })})`,
        value: `BIWEEK_${fortniteNum}`,
        startDate: formatISO(current),
        endDate: formatISO(actualEnd)
      });
      current.setDate(current.getDate() + 14);
      fortniteNum++;
    }
    return periods;
  }

  // 3. ANNUAL (12 Months Interval)
  if (
    normalizedCycle.includes("12_MONTH") || 
    normalizedCycle.includes("ANNUAL") || 
    normalizedCycle.includes("YEAR")
  ) {
    return [
      { label: "Annual (Apr - Mar)", value: "ANNUAL", startDate: `${fyYear}-04-01`, endDate: `${fyYear + 1}-03-31` }
    ];
  }

  // 4. HALF-YEARLY (6 Months Interval)
  if (
    normalizedCycle.includes("6_MONTH") || 
    normalizedCycle.includes("HALF") || 
    normalizedCycle.includes("MID")
  ) {
    return [
      { label: "H1 / First Half (Apr - Sep)", value: "H1", startDate: `${fyYear}-04-01`, endDate: `${fyYear}-09-30` },
      { label: "H2 / Second Half (Oct - Mar)", value: "H2", startDate: `${fyYear}-10-01`, endDate: `${fyYear + 1}-03-31` }
    ];
  }

  // 5. QUARTERLY (3 Months Interval)
  if (
    normalizedCycle.includes("QUARTER") || 
    normalizedCycle.includes("Q1") || 
    normalizedCycle.includes("3_MONTH")
  ) {
    return [
      { label: "Q1 (Apr - Jun)", value: "Q1", startDate: `${fyYear}-04-01`, endDate: `${fyYear}-06-30` },
      { label: "Q2 (Jul - Sep)", value: "Q2", startDate: `${fyYear}-07-01`, endDate: `${fyYear}-09-30` },
      { label: "Q3 (Oct - Dec)", value: "Q3", startDate: `${fyYear}-10-01`, endDate: `${fyYear}-12-31` },
      { label: "Q4 (Jan - Mar)", value: "Q4", startDate: `${fyYear + 1}-01-01`, endDate: `${fyYear + 1}-03-31` }
    ];
  }

  // 6. MONTHLY (1 Month Interval starting from April)
  if (normalizedCycle.includes("MONTH") || normalizedCycle.includes("1_MONTH")) {
    const months = [
      { name: "April", num: 4, yrOffset: 0 },
      { name: "May", num: 5, yrOffset: 0 },
      { name: "June", num: 6, yrOffset: 0 },
      { name: "July", num: 7, yrOffset: 0 },
      { name: "August", num: 8, yrOffset: 0 },
      { name: "September", num: 9, yrOffset: 0 },
      { name: "October", num: 10, yrOffset: 0 },
      { name: "November", num: 11, yrOffset: 0 },
      { name: "December", num: 12, yrOffset: 0 },
      { name: "January", num: 1, yrOffset: 1 },
      { name: "February", num: 2, yrOffset: 1 },
      { name: "March", num: 3, yrOffset: 1 }
    ];

    return months.map(m => {
      const currentYr = fyYear + m.yrOffset;
      const lastDay = getLastDayOfMonth(currentYr, m.num);
      return {
        label: `${m.name} (${fyYear}-${String(fyYear + 1).slice(-2)})`,
        value: m.name.toUpperCase(),
        startDate: `${currentYr}-${pad(m.num)}-01`,
        endDate: `${currentYr}-${pad(m.num)}-${pad(lastDay)}`
      };
    });
  }

  return [
    { label: "Annual (Apr - Mar)", value: "ANNUAL", startDate: `${fyYear}-04-01`, endDate: `${fyYear + 1}-03-31` }
  ];
};

export default function KraAssignmentsList() {
  const [loading, setLoading] = useState(true);
  const [assignments, setAssignments] = useState([]);
  const [selectedAssignment, setSelectedAssignment] = useState(null); 

  // Filter dependencies lists
  const [departments, setDepartments] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [employees, setEmployees] = useState([]);

  // Selected Filter States
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");

  const [selectedRowIds, setSelectedRowIds] = useState([]);

  // Review Initiate Modals States
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [showCronModal, setShowCronModal] = useState(false);
  const [submittingReview, setSubmittingReview] = useState(false);

  // Edit Assignment Modal States
  const [showEditModal, setShowEditModal] = useState(false);
  const [updatingAssignment, setUpdatingAssignment] = useState(false);
  const [editForm, setEditForm] = useState({
    id: "",
    employeeName: "",
    startDate: "",
    endDate: "",
    reviewCycle: "",
    workflowId: "",
    kras: []
  });

  // Delete Offcanvas States
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState(null);

  // Modal Form State (Single)
  const [reviewForm, setReviewForm] = useState({
    userId: "",
    employeeName: "",
    year: "",
    cycleType: "",
    period: "",
    startDate: "",
    endDate: "",
    periodsList: [] 
  });

  // Modal Form State (Bulk)
  const [bulkForm, setBulkForm] = useState({
    year: new Date().getFullYear(),
    cycleType: "3_MONTHS",
    period: "Q1",
    startDate: `${new Date().getFullYear()}-04-01`,
    endDate: `${new Date().getFullYear()}-06-30`,
    periodsList: getAvailablePeriods("3_MONTHS", new Date().getFullYear())
  });

  // Modal Form State (Cron Automation)
  const [cronForm, setCronForm] = useState({
    year: new Date().getFullYear(),
    cycleType: "3_MONTHS",
    period: "Q1",
    startDate: `${new Date().getFullYear()}-04-01`,
    endDate: `${new Date().getFullYear()}-06-30`,
    periodsList: getAvailablePeriods("3_MONTHS", new Date().getFullYear())
  });

  const handleOpenReviewModal = useCallback((row) => {
    const user = row.userId || {};
    const year = Number(row.year) || new Date().getFullYear();
    const cycleType = row.reviewCycle || "3_MONTHS"; 

    const dynamicPeriods = getAvailablePeriods(cycleType, year);
    const defaultPeriod = dynamicPeriods[0] || {};

    setReviewForm({
      userId: user._id || user.id || "",
      employeeName: `${user.firstName || ""} ${user.lastName || ""}`,
      year: year,
      cycleType: cycleType,
      period: defaultPeriod.value || "",
      startDate: defaultPeriod.startDate || "",
      endDate: defaultPeriod.endDate || "",
      periodsList: dynamicPeriods 
    });
    setShowReviewModal(true);
  }, []);

  const handleOpenEditModal = (row) => {
    const user = row.userId || {};
    setEditForm({
      id: row._id,
      employeeName: `${user.firstName || ""} ${user.lastName || ""}`,
      startDate: row.startDate ? row.startDate.substring(0, 10) : "",
      endDate: row.endDate ? row.endDate.substring(0, 10) : "",
      reviewCycle: row.reviewCycle || "3_MONTHS",
      workflowId: row.workflowId?._id || row.workflowId || "",
      kras: row.kras?.map(k => ({
        kraId: k.kraId?._id || k.kraId,
        name: k.name || "",
        description: k.description || "",
        category: k.category || "Technical",
        weightage: k.weightage || 0,
        reviewCycle: k.reviewCycle || "3_MONTHS",
        targetValue: k.targetValue || "",
        metricType: k.metricType || k.kraId?.metricType || "HIGHER_IS_BETTER", // ✅ Synchronized metricType
        monthlyTarget: k.monthlyTarget || "",
        yearlyTarget: k.yearlyTarget || ""
      })) || []
    });
    setShowEditModal(true);
  };

  const handleEditKrasChange = (index, key, val) => {
    const updated = editForm.kras.map((k, idx) => 
      idx === index ? { ...k, [key]: val } : k
    );
    setEditForm(p => ({ ...p, kras: updated }));
  };

  const handleAutoSplitEditWeights = () => {
    const totalKras = editForm.kras.length;
    if (totalKras === 0) return;

    const baseWeight = Math.floor(100 / totalKras);
    const remainder = 100 % totalKras;

    const updated = editForm.kras.map((k, idx) => {
      const weight = idx < remainder ? baseWeight + 1 : baseWeight;
      return { ...k, weightage: weight };
    });

    setEditForm(p => ({ ...p, kras: updated }));
    toast.info("Weights distributed equally across edit fields.");
  };

  const totalEditWeightSum = useMemo(() => {
    return editForm.kras.reduce((sum, k) => sum + Number(k.weightage || 0), 0);
  }, [editForm.kras]);

  const handleEditAssignmentSubmit = async (e) => {
    e.preventDefault();
    if (totalEditWeightSum !== 100) {
      return toast.error(`Total weightage must equal 100%. Current: ${totalEditWeightSum}%`);
    }

    setUpdatingAssignment(true);
    try {
      const payload = {
        startDate: editForm.startDate,
        endDate: editForm.endDate,
        reviewCycle: editForm.reviewCycle,
        workflowId: editForm.workflowId,
        krasInput: editForm.kras.map(k => ({
          kraId: k.kraId,
          weightage: k.weightage,
          reviewCycle: k.reviewCycle,
          targetValue: k.targetValue,
          metricType: k.metricType || "HIGHER_IS_BETTER", // ✅ Added metricType payload
          monthlyTarget: k.monthlyTarget,
          yearlyTarget: k.yearlyTarget
        }))
      };

      const res = await api.put(SummaryApi.updateAssignKra.url(editForm.id), payload);
      if (res.data.success) {
        toast.success("Assignment updated and employee acknowledgment request reset.");
        setShowEditModal(false);
        setAssignments(prev => prev.map(a => a._id === editForm.id ? res.data.data : a));
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update assignment.");
    } finally {
      setUpdatingAssignment(false);
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCycle, setSelectedCycle] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedYear, setSelectedYear] = useState(""); 
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const loadAssignmentsAndFilters = useCallback(async () => {
    setLoading(true);
    try {
      const url = SummaryApi.listKraAssignments?.url || "/api/hr/kra/assignments/view-all";
      const employeesEndpoint = SummaryApi.getAllUsers?.url || "/api/hr/employees/active-list";
      
      const [assignRes, deptRes, divRes, empRes] = await Promise.all([
        api.get(url),
        api.get(SummaryApi.getAllDepartments.url),
        api.get(SummaryApi.getAllDivisions.url),
        api.get(employeesEndpoint)
      ]);

      if (assignRes.data.success) setAssignments(assignRes.data.data || []);
      if (deptRes.data.success) setDepartments(deptRes.data.data.map(d => ({ label: d.name, value: d._id })));
      if (divRes.data.success) setDivisions(divRes.data.data.map(d => ({ label: d.name, value: d._id })));
      if (empRes.data.success) setEmployees(empRes.data.data.map(e => ({ label: `${e.firstName} ${e.lastName}`, value: e._id })));
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load active structures.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadAssignmentsAndFilters();
  }, [loadAssignmentsAndFilters]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, selectedCycle, selectedStatus, selectedDepartment, selectedDivision, selectedEmployee, selectedYear]);

  const cycles = useMemo(() => {
    const list = assignments.map(a => a.reviewCycle).filter(Boolean);
    return [
      ...new Set(list)
    ].map(item => typeof item === "string" ? { label: item.replace("_", " "), value: item } : item);
  }, [assignments]);

  const years = useMemo(() => {
    const yearsList = [];
    const startYear = 2025; 
    const currentYear = new Date().getFullYear(); 

    for (let y = currentYear; y >= startYear; y--) {
      yearsList.push({ label: `FY ${y}`, value: y });
    }

    assignments.forEach(a => {
      if (a.year && a.year < startYear && !yearsList.some(item => item.value === a.year)) {
        yearsList.push({ label: `FY ${a.year}`, value: a.year });
      }
    });

    return yearsList.sort((a, b) => b.value - a.value);
  }, [assignments]);

  const stats = useMemo(() => {
    const totalCount = assignments.length;
    const acknowledgedCount = assignments.filter(a => a.employeeStatus === "ACKNOWLEDGED").length;
    const pendingCount = assignments.filter(a => a.employeeStatus === "PENDING_ACKNOWLEDGEMENT").length;
    
    const totalKras = assignments.reduce((sum, a) => sum + (a.kras?.length || 0), 0);
    const avgKras = totalCount > 0 ? (totalKras / totalCount).toFixed(1) : "0.0";

    return { totalCount, acknowledgedCount, pendingCount, avgKras };
  }, [assignments]);

  const filteredAssignments = useMemo(() => {
    return assignments.filter(a => {
      const user = a.userId || {};
      const fullName = `${user.firstName || ""} ${user.lastName || ""}`.toLowerCase();
      
      const matchesSearch = fullName.includes(searchQuery.toLowerCase()) || 
                            (user.userId && user.userId.toLowerCase().includes(searchQuery.toLowerCase()));

      const matchesCycle = !selectedCycle || a.reviewCycle === selectedCycle;
      const matchesStatus = !selectedStatus || a.employeeStatus === selectedStatus;
      
      const matchesYear = !selectedYear || selectedYear === "" || Number(a.year) === Number(selectedYear);

      const uDeptId = user.departmentId?._id || user.departmentId;
      const uDivId = user.divisionId?._id || user.divisionId;

      const matchesDepartment = !selectedDepartment || uDeptId === selectedDepartment;
      const matchesDivision = !selectedDivision || uDivId === selectedDivision;
      const matchesEmployee = !selectedEmployee || user._id === selectedEmployee;

      return matchesSearch && matchesCycle && matchesStatus && matchesYear && matchesDepartment && matchesDivision && matchesEmployee;
    });
  }, [assignments, searchQuery, selectedCycle, selectedStatus, selectedDepartment, selectedDivision, selectedEmployee, selectedYear]);

  const paginatedAssignments = useMemo(() => {
    const startIdx = (currentPage - 1) * itemsPerPage;
    return filteredAssignments.slice(startIdx, startIdx + itemsPerPage);
  }, [filteredAssignments, currentPage]);

  const handleInitiateReviewSubmit = async (e) => {
    e.preventDefault();
    setSubmittingReview(true);
    try {
      const payload = {
        userId: reviewForm.userId,
        year: Number(reviewForm.year),
        period: reviewForm.period,
        startDate: new Date(reviewForm.startDate).toISOString(),
        endDate: new Date(reviewForm.endDate).toISOString()
      };

      const url = SummaryApi.reviewInitiateKra?.url || "/api/hr/kra/appraisals/initiate";
      const method = SummaryApi.reviewInitiateKra?.method || "post";

      const res = await api({
        url,
        method,
        data: payload
      });

      if (res.data.success) {
        toast.success(res.data.message || "Review initiated successfully!");
        setShowReviewModal(false);
      } else {
        toast.error(res.data.message || "Failed to initiate review.");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error initiating review process.");
    } finally {
      setSubmittingReview(false);
    }
  };

  const handleBulkInitiateSubmit = async (e) => {
    e.preventDefault();
    setSubmittingReview(true);
    try {
      const selectedAssignments = assignments.filter(a => selectedRowIds.includes(a._id));
      const userIds = selectedAssignments.map(a => a.userId?._id || a.userId).filter(Boolean);

      if (userIds.length === 0) {
        return toast.error("No valid employees selected.");
      }

      const payload = {
        userIds,
        year: Number(bulkForm.year),
        period: bulkForm.period,
        startDate: new Date(bulkForm.startDate).toISOString(),
        endDate: new Date(bulkForm.endDate).toISOString()
      };

      const res = await api.post(SummaryApi.bulkReviewInitiateKra?.url || "/api/hr/kra/appraisals/bulk-initiate", payload);
      if (res.data.success) {
        const { processed, errors } = res.data.data;
        toast.success(`Appraisals initiated for ${processed.length} employees.`);
        if (errors && errors.length > 0) {
          toast.warning(`${errors.length} sheets skipped due to duplicate initiation rules.`);
        }
        setShowBulkModal(false);
        setSelectedRowIds([]); 
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Bulk initiation failed.");
    } finally {
      setSubmittingReview(false);
    }
  };

  const handleCronInitiateSubmit = async (e) => {
    e.preventDefault();
    setSubmittingReview(true);
    try {
      const payload = {
        year: Number(cronForm.year),
        period: cronForm.period,
        startDate: new Date(cronForm.startDate).toISOString(),
        endDate: new Date(cronForm.endDate).toISOString()
      };

      const res = await api.post(SummaryApi.autoInitiateReviews.url, payload);
      if (res.data.success) {
        const { totalProcessed, errors } = res.data.data;
        toast.success(`Automation Complete! Generated ${totalProcessed} appraisal review sheets.`);
        if (errors && errors.length > 0) {
          toast.warning(`${errors.length} sheets skipped.`);
        }
        setShowCronModal(false);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Cron simulation process failed.");
    } finally {
      setSubmittingReview(false);
    }
  };

  const handleDeleteClick = (row) => {
    setItemToDelete(row);
    setDeleteError(null);
    setIsDeleteOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!itemToDelete) return;
    setIsDeleting(true);
    setDeleteError(null);
    try {
      const url = SummaryApi.deleteEmployeeKras.url(itemToDelete._id);
      await api.delete(url);
      toast.success("Successfully deleted KRA assignment.");
      setAssignments(p => p.filter(a => a._id !== itemToDelete._id));
      setIsDeleteOpen(false);
      setItemToDelete(null);
    } catch (err) {
      const errMsg = err.response?.data?.message || "Deletion failed.";
      setDeleteError({ message: errMsg, users: [] });
      toast.error(errMsg);
    } finally {
      setIsDeleting(false);
    }
  };

  const resetAllFilters = () => {
    setSelectedDepartment("");
    setSelectedDivision("");
    setSelectedEmployee("");
    setSelectedCycle("");
    setSelectedStatus("");
    setSelectedYear(""); 
    setSearchQuery("");
  };

  const columns = useMemo(() => [
    {
      key: "employee",
      label: "Employee",
      render: (row) => {
        const user = row.userId || {};
        return (
          <div className="flex items-center gap-3">
            {user.profilePicture ? (
              <img src={user.profilePicture} alt="" className="w-8 h-8 rounded-full object-cover shrink-0" />
            ) : (
              <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center text-red-600 text-[10px] font-bold shrink-0">
                {user.firstName?.[0] || ""}{user.lastName?.[0] || ""}
              </div>
            )}
            <div>
              <p className="font-bold text-slate-900 whitespace-nowrap">{user.firstName} {user.lastName}</p>
              <p className="text-[10px] text-slate-400 font-medium whitespace-nowrap">{user.email}</p>
            </div>
          </div>
        );
      }
    },
    {
      key: "employeeId",
      label: "Employee ID",
      render: (row) => {
        const user = row.userId || {};
        return <span className="font-semibold text-slate-500">{user.userId || "EMP-N/A"}</span>;
      }
    },
    {
      key: "year",
      label: "Year",
      render: (row) => <span className="text-slate-500">FY {row.year}</span>
    },
    {
      key: "workflow",
      label: "Workflow Configuration",
      render: (row) => {
        const workflow = row.workflowId || {};
        return <span className="text-slate-500 font-medium">{workflow.name || "Default KRA Stage Flow"}</span>;
      }
    },
    {
      key: "goals",
      label: "Assigned Goals",
      headerAlign: "center",
      render: (row) => {
        const kraCount = row.kras?.length || 0;
        return (
          <span className="bg-slate-100 text-slate-700 border font-bold px-2.5 py-0.5 rounded-full text-[10px]">
            {kraCount} Goals Assigned
          </span>
        );
      }
    },
    {
      key: "reviewCycle",
      label: "Review Cycle",
      render: (row) => (
        <span className="text-slate-500 uppercase tracking-wider text-[10px] font-bold">
          {formatCycleDisplay(row.reviewCycle)}
        </span>
      )
    },
    {
      key: "status",
      label: "Ack Status",
      render: (row) => (
        <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border uppercase tracking-wider ${
          row.employeeStatus === "ACKNOWLEDGED" 
            ? "bg-green-50 text-green-700 border-green-200" 
            : row.employeeStatus === "PENDING_ACKNOWLEDGEMENT"
            ? "bg-amber-50 text-amber-700 border-amber-200"
            : "bg-red-50 text-red-700 border-red-200"
        }`}>
          {row.employeeStatus?.replace("_", " ")}
        </span>
      )
    }
  ], []);

  const tableActions = useMemo(() => [
    {
      key: "view",
      label: "View KRAs",
      icon: <Eye className="w-4 h-4 text-slate-500" />,
      onClick: (row) => setSelectedAssignment(row)
    },
    {
      key: "edit",
      label: "Edit Targets",
      icon: <Edit3 className="w-4 h-4 text-blue-500" />,
      onClick: (row) => handleOpenEditModal(row)
    },
    {
      key: "initiate",
      label: "Initiate Review",
      icon: <Play className="w-4 h-4 text-emerald-500" />,
      onClick: (row) => handleOpenReviewModal(row),
      show: (row) => row.employeeStatus === "ACKNOWLEDGED",
    },
    {
      key: "delete",
      label: "Delete Assignment",
      icon: <Trash2 className="w-4 h-4 text-red-500" />,
      onClick: (row) => handleDeleteClick(row),
      show: () => true 
    }
  ], [handleOpenReviewModal]);

  if (loading) return <PageLoader />;

  return (
    <>

    <div className="space-y-4 animate-in fade-in duration-300">
      
      {/* HEADER CONTROLS WITH REVIEWS BULK & CRON TRIGGERS */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="text-left">
          <h1 className="text-lg md:text-xl font-bold text-slate-900 tracking-tight">KRA Goal Assignments</h1>
          <p className="text-xs text-slate-400 mt-1">Review assigned goals, categories, and weightages before initiating appraisals.</p>
        </div>

        <div className="flex items-center gap-3 self-end sm:self-auto">
          {selectedRowIds.length > 0 && (
            <button 
              onClick={() => setShowBulkModal(true)}
              className="flex items-center gap-1.5 bg-primary hover:bg-secondary text-white px-4 py-2 rounded-lg font-bold text-xs uppercase hover:shadow-lg transition-all"
            >
              <Play className="w-4 h-4" /> Bulk Initiate Appraisal ({selectedRowIds.length})
            </button>
          )}

          <button 
            onClick={() => setShowCronModal(true)}
            className="flex items-center gap-1.5 bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-lg font-bold text-xs uppercase hover:shadow-lg transition-all"
          >
            <Cpu className="w-4 h-4" /> Run Auto-Cron
          </button>
        </div>
      </div>

      {/* STATS ROW */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
        <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
          <div className="w-12 h-12 bg-blue-50 border border-blue-100 rounded-full flex items-center justify-center text-blue-600 shrink-0">
            <Users className="w-5 h-5" />
          </div>
          <div className="text-left">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Total Assignments</span>
            <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.totalCount}</p>
            <span className="text-[10px] text-slate-400 font-semibold">Active employees KRA</span>
          </div>
        </div>

        <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
          <div className="w-12 h-12 bg-green-50 border border-green-100 rounded-full flex items-center justify-center text-green-600 shrink-0">
            <CheckCircle2 className="w-5 h-5" />
          </div>
          <div className="text-left">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Acknowledged</span>
            <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.acknowledgedCount}</p>
            <span className="text-[10px] text-green-600 font-semibold">Accepted by employees</span>
          </div>
        </div>

        <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
          <div className="w-12 h-12 bg-amber-50 border border-amber-100 rounded-full flex items-center justify-center text-amber-600 shrink-0">
            <Clock className="w-5 h-5" />
          </div>
          <div className="text-left">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Pending Acceptance</span>
            <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.pendingCount}</p>
            <span className="text-[10px] text-amber-600 font-semibold">Waiting for action</span>
          </div>
        </div>

        <div className="bg-white border rounded-2xl p-5 shadow-sm flex items-center gap-4">
          <div className="w-12 h-12 bg-pink-50 border border-pink-100 rounded-full flex items-center justify-center text-pink-500 shrink-0">
            <Layers className="w-5 h-5" />
          </div>
          <div className="text-left">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Average KRAs</span>
            <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.avgKras}</p>
            <span className="text-[10px] text-slate-400 font-semibold">Goals per employee</span>
          </div>
        </div>
      </div>

      {/* FILTER SEARCH PANEL */}
      <div className="bg-white border rounded-xl p-5 shadow-sm space-y-4">
        <div className="flex flex-wrap items-center gap-4">
          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Review Cycle</span>
            <SelectDropdown options={cycles} value={selectedCycle} onChange={setSelectedCycle} placeholder="All Cycles" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
          </div>

          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Ack Status</span>
            <SelectDropdown options={[{ label: "Acknowledged", value: "ACKNOWLEDGED" }, { label: "Pending", value: "PENDING_ACKNOWLEDGEMENT" }, { label: "Disputed", value: "DISPUTED" }]} value={selectedStatus} onChange={setSelectedStatus} placeholder="All Status" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
          </div>

          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Review Year</span>
            <SelectDropdown options={years} value={selectedYear} onChange={setSelectedYear} placeholder="All Years" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
          </div>

          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Division</span>
            <SelectDropdown options={divisions} value={selectedDivision} onChange={setSelectedDivision} placeholder="All Divisions" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
          </div>

          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Department</span>
            <SelectDropdown options={departments} value={selectedDepartment} onChange={setSelectedDepartment} placeholder="All Departments" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
          </div>

          <div className="w-48">
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1.5">Employee Selection</span>
            <SelectDropdown options={employees} value={selectedEmployee} onChange={setSelectedEmployee} placeholder="All Employees" valueKey="value" labelKey="label" ChildClassName="h-9 text-xs border-slate-200" searchable={true} />
          </div>

          <button type="button" onClick={resetAllFilters} className="flex items-center gap-1.5 px-4 py-2 border rounded-lg text-xs font-semibold h-9 mt-5 border-slate-200 hover:bg-slate-50 transition-colors">
            <X className="h-4 w-4" /> Reset Filters
          </button>
        </div>

        <div className="relative pt-1">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-3.5" />
          <input 
            type="text" 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search employees dynamically by name or ID..."
            className="w-full border border-slate-200 rounded-lg pl-9 pr-4 py-1.5 text-xs outline-none focus:ring-1 focus:ring-red-200 h-9"
          />
        </div>
      </div>

      {/* MODERN TABLE */}
      <div className="">
        <div className="pb-4 flex justify-between items-center">
          <span className="font-bold text-slate-800 text-lg">Employee Goal Setup ({filteredAssignments.length})</span>
        </div>

        <ModernTable 
          columns={columns}
          data={paginatedAssignments}
          actions={tableActions}
          actionType="dropdown" 
          selectable={true} 
          selectedRows={selectedRowIds} 
          onSelectionChange={setSelectedRowIds} 
          stickyColumns={1}
          isRowSelectable={(row) => row.employeeStatus === "ACKNOWLEDGED"} 
          pagination={{
            totalItems: filteredAssignments.length,
            itemsPerPage: itemsPerPage,
            currentPage: currentPage,
            onPageChange: setCurrentPage
          }}
        />
      </div>
     </div>
    
      {/* INITIATE REVIEW MODAL (SINGLE) */}
      {showReviewModal && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl border flex flex-col max-h-[90vh] sm:max-h-[85vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            
            <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
              <div className="flex gap-3 items-center">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0 border border-emerald-100">
                  <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
                </div>
                <div className="text-left">
                  <h3 className="font-bold text-gray-900 text-xs sm:text-base leading-tight">
                    Initiate KRA Appraisal
                  </h3>
                  <p className="text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mt-0.5">
                    Review Cycle Initiation Setup
                  </p>
                </div>
              </div>
              <button 
                onClick={() => setShowReviewModal(false)}
                className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg transition-colors border"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            <form onSubmit={handleInitiateReviewSubmit} className="flex flex-col flex-1 overflow-hidden">
              <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar">
                <div className="text-left">
                  <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Employee</label>
                  <input 
                    type="text" 
                    readOnly 
                    disabled
                    value={reviewForm.employeeName}
                    className="w-full border rounded-lg px-3 py-2 text-xs bg-slate-50 text-slate-500 font-semibold border-slate-200 focus:outline-none"
                  />
                </div>

                <div className="text-left">
                  <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Review Frequency</label>
                  <select
                    value={reviewForm.cycleType}
                    onChange={(e) => {
                      const selectedCycle = e.target.value;
                      const dynamicPeriods = getAvailablePeriods(selectedCycle, reviewForm.year);
                      const defaultPeriod = dynamicPeriods[0] || {};
                      setReviewForm(prev => ({
                        ...prev,
                        cycleType: selectedCycle,
                        period: defaultPeriod.value || "",
                        startDate: defaultPeriod.startDate || "",
                        endDate: defaultPeriod.endDate || "",
                        periodsList: dynamicPeriods
                      }));
                    }}
                    className="w-full border border-slate-200 rounded-lg px-3 py-2 text-xs font-semibold text-slate-700 bg-white focus:outline-none focus:ring-1 focus:ring-red-200 h-9"
                  >
                    <option value="1_WEEK">Weekly</option>
                    <option value="2_WEEKS">Bi-weekly</option>
                    <option value="1_MONTH">Monthly</option>
                    <option value="3_MONTHS">Quarterly</option>
                    <option value="6_MONTHS">Half-Yearly</option>
                    <option value="12_MONTHS">Annual</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Year</label>
                    <input 
                      type="text" 
                      readOnly 
                      disabled
                      value={`FY ${reviewForm.year}`}
                      className="w-full border rounded-lg px-3 py-2 text-xs bg-slate-50 text-slate-500 font-semibold border-slate-200 focus:outline-none"
                    />
                  </div>
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Period</label>
                    <select
                      value={reviewForm.period}
                      onChange={(e) => {
                        const selectedVal = e.target.value;
                        const match = reviewForm.periodsList.find(p => p.value === selectedVal);
                        if (match) {
                          setReviewForm(prev => ({
                            ...prev,
                            period: selectedVal,
                            startDate: match.startDate,
                            endDate: match.endDate
                          }));
                        }
                      }}
                      className="w-full border rounded-lg px-3 py-2 text-xs font-semibold border-slate-200 text-slate-700 bg-white focus:outline-none focus:ring-1 focus:ring-red-200"
                    >
                      {reviewForm.periodsList.map((p) => (
                        <option key={p.value} value={p.value}>
                          {p.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Start Date</label>
                    <input 
                      type="date"
                      required
                      value={reviewForm.startDate}
                      onChange={(e) => setReviewForm(prev => ({ ...prev, startDate: e.target.value }))}
                      className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
                    />
                  </div>
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">End Date</label>
                    <input 
                      type="date"
                      required
                      value={reviewForm.endDate}
                      onChange={(e) => setReviewForm(prev => ({ ...prev, endDate: e.target.value }))}
                      className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
                    />
                  </div>
                </div>
              </div>

              <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
                <button
                  type="button"
                  onClick={() => setShowReviewModal(false)}
                  className="px-3 py-2 sm:px-4 bg-white hover:bg-slate-50 text-slate-700 border rounded-lg text-[10px] sm:text-xs font-bold uppercase transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={submittingReview}
                  className="px-3 py-2 sm:px-4 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-[10px] sm:text-xs font-bold uppercase transition-colors disabled:opacity-50"
                >
                  {submittingReview ? "Initiating..." : "Initiate Review"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* BULK REVIEW INITIATION MODAL */}
      {showBulkModal && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl border flex flex-col max-h-[90vh] sm:max-h-[85vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
              <div className="flex gap-3 items-center">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-blue-50 text-primary flex items-center justify-center shrink-0 border border-blue-100">
                  <Play className="w-4 h-4 sm:w-5 sm:h-5" />
                </div>
                <div className="text-left">
                  <h3 className="font-bold text-gray-900 text-xs sm:text-base leading-tight">Bulk Initiate Appraisal</h3>
                  <p className="text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mt-0.5">Bulk Setup for {selectedRowIds.length} members</p>
                </div>
              </div>
              <button onClick={() => setShowBulkModal(false)} className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg transition-colors border">
                <X className="w-4 h-4" />
              </button>
            </div>

            <form onSubmit={handleBulkInitiateSubmit} className="flex flex-col flex-1 overflow-hidden">
              <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar">
                
                <div className="text-left">
                  <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Review Frequency</label>
                  <select
                    value={bulkForm.cycleType || "3_MONTHS"}
                    onChange={(e) => {
                      const selectedCycle = e.target.value;
                      const dynamicPeriods = getAvailablePeriods(selectedCycle, bulkForm.year);
                      const defaultPeriod = dynamicPeriods[0] || {};
                      setBulkForm(p => ({
                        ...p,
                        cycleType: selectedCycle,
                        period: defaultPeriod.value || "",
                        startDate: defaultPeriod.startDate || "",
                        endDate: defaultPeriod.endDate || "",
                        periodsList: dynamicPeriods
                      }));
                    }}
                    className="w-full border border-slate-200 rounded-lg px-3 py-2 text-xs font-semibold text-slate-700 bg-white focus:outline-none focus:ring-1 focus:ring-red-200 h-9"
                  >
                    <option value="1_WEEK">Weekly</option>
                    <option value="2_WEEKS">Bi-weekly</option>
                    <option value="1_MONTH">Monthly</option>
                    <option value="3_MONTHS">Quarterly</option>
                    <option value="6_MONTHS">Half-Yearly</option>
                    <option value="12_MONTHS">Annual</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Financial Year</label>
                    <input 
                      type="number" 
                      value={bulkForm.year} 
                      onChange={(e) => {
                        const yr = Number(e.target.value) || new Date().getFullYear();
                        setBulkForm(p => ({ ...p, year: yr, periodsList: getAvailablePeriods(p.cycleType || "3_MONTHS", yr) }));
                      }} 
                      className="w-full border rounded-lg px-3 py-2 text-xs text-slate-700 font-semibold focus:outline-none focus:ring-1 focus:ring-red-200" 
                    />
                  </div>
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Review Period</label>
                    <select
                      value={bulkForm.period}
                      onChange={(e) => {
                        const selectedVal = e.target.value;
                        const match = bulkForm.periodsList.find(p => p.value === selectedVal);
                        if (match) {
                          setBulkForm(p => ({ ...p, period: selectedVal, startDate: match.startDate, endDate: match.endDate }));
                        }
                      }}
                      className="w-full border rounded-lg px-3 py-2 text-xs font-semibold border-slate-200 text-slate-700 bg-white focus:outline-none focus:ring-1 focus:ring-red-200"
                    >
                      {bulkForm.periodsList.map((p) => (
                        <option key={p.value} value={p.value}>{p.label}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Start Date</label>
                    <input type="date" required value={bulkForm.startDate} onChange={(e) => setBulkForm(p => ({ ...p, startDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none" />
                  </div>
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">End Date</label>
                    <input type="date" required value={bulkForm.endDate} onChange={(e) => setBulkForm(p => ({ ...p, endDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none" />
                  </div>
                </div>
              </div>

              <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
                <button type="button" onClick={() => setShowBulkModal(false)} className="px-4 py-2 bg-white text-slate-700 border rounded-lg text-xs font-bold uppercase">Cancel</button>
                <button type="submit" disabled={submittingReview} className="px-4 py-2 bg-primary text-white rounded-lg text-xs font-bold uppercase disabled:opacity-50">
                  {submittingReview ? "Initiating Bulk..." : "Bulk Initiate"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* RUN AUTO-CRON SIMULATION MODAL */}
      {showCronModal && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl border flex flex-col max-h-[90vh] sm:max-h-[85vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
              <div className="flex gap-3 items-center">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center shrink-0 border border-amber-100">
                  <Cpu className="w-4 h-4 sm:w-5 sm:h-5" />
                </div>
                <div className="text-left">
                  <h3 className="font-bold text-gray-900 text-xs sm:text-base leading-tight">Auto-Cron Appraisal Simulation</h3>
                  <p className="text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mt-0.5">Automates review sheets for all active profiles</p>
                </div>
              </div>
              <button onClick={() => setShowCronModal(false)} className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg transition-colors border">
                <X className="w-4 h-4" />
              </button>
            </div>

            <form onSubmit={handleCronInitiateSubmit} className="flex flex-col flex-1 overflow-hidden">
              <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar">
                
                <div className="text-left">
                  <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Review Frequency</label>
                  <select
                    value={cronForm.cycleType || "3_MONTHS"}
                    onChange={(e) => {
                      const selectedCycle = e.target.value;
                      const dynamicPeriods = getAvailablePeriods(selectedCycle, cronForm.year);
                      const defaultPeriod = dynamicPeriods[0] || {};
                      setCronForm(p => ({
                        ...p,
                        cycleType: selectedCycle,
                        period: defaultPeriod.value || "",
                        startDate: defaultPeriod.startDate || "",
                        endDate: defaultPeriod.endDate || "",
                        periodsList: dynamicPeriods
                      }));
                    }}
                    className="w-full border border-slate-200 rounded-lg px-3 py-2 text-xs font-semibold text-slate-700 bg-white focus:outline-none focus:ring-1 focus:ring-red-200 h-9"
                  >
                    <option value="1_WEEK">Weekly</option>
                    <option value="2_WEEKS">Bi-weekly</option>
                    <option value="1_MONTH">Monthly</option>
                    <option value="3_MONTHS">Quarterly</option>
                    <option value="6_MONTHS">Half-Yearly</option>
                    <option value="12_MONTHS">Annual</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Financial Year</label>
                    <input 
                      type="number" 
                      value={cronForm.year} 
                      onChange={(e) => {
                        const yr = Number(e.target.value) || new Date().getFullYear();
                        setCronForm(p => ({ ...p, year: yr, periodsList: getAvailablePeriods(p.cycleType || "3_MONTHS", yr) }));
                      }} 
                      className="w-full border rounded-lg px-3 py-2 text-xs text-slate-700 font-semibold focus:outline-none focus:ring-1 focus:ring-red-200" 
                    />
                  </div>
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Review Period</label>
                    <select
                      value={cronForm.period}
                      onChange={(e) => {
                        const selectedVal = e.target.value;
                        const match = cronForm.periodsList.find(p => p.value === selectedVal);
                        if (match) {
                          setCronForm(p => ({ ...p, period: selectedVal, startDate: match.startDate, endDate: match.endDate }));
                        }
                      }}
                      className="w-full border rounded-lg px-3 py-2 text-xs font-semibold border-slate-200 text-slate-700 bg-white focus:outline-none"
                    >
                      {cronForm.periodsList.map((p) => (
                        <option key={p.value} value={p.value}>{p.label}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left">
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">Start Date</label>
                    <input type="date" required value={cronForm.startDate} onChange={(e) => setCronForm(p => ({ ...p, startDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none" />
                  </div>
                  <div>
                    <label className="block text-[9px] sm:text-[10px] text-gray-400 font-bold uppercase mb-1">End Date</label>
                    <input type="date" required value={cronForm.endDate} onChange={(e) => setCronForm(p => ({ ...p, endDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700 font-medium focus:outline-none" />
                  </div>
                </div>
              </div>

              <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
                <button type="button" onClick={() => setShowCronModal(false)} className="px-4 py-2 bg-white text-slate-700 border rounded-lg text-xs font-bold uppercase">Cancel</button>
                <button type="submit" disabled={submittingReview} className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-xs font-bold uppercase disabled:opacity-50">
                  {submittingReview ? "Executing Cron..." : "Trigger Auto-Cron"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* EDIT KRA ASSIGNMENT GOALS & TARGETS MODAL */}
      {showEditModal && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl border flex flex-col max-h-[88vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200 text-left">
            <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
              <div className="flex gap-3 items-center">
                <div className="w-10 h-10 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center shrink-0 border border-blue-100">
                  <Edit3 className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-950 text-sm sm:text-base leading-tight">Edit KRA Assignment Details</h3>
                  <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">{editForm.employeeName}</p>
                </div>
              </div>
              <button onClick={() => setShowEditModal(false)} className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg border transition-all"><X className="w-4 h-4" /></button>
            </div>

            <form onSubmit={handleEditAssignmentSubmit} className="flex flex-col flex-1 overflow-hidden">
              <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar bg-slate-50/30">
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Start Date</label>
                    <input type="date" required value={editForm.startDate} onChange={(e) => setEditForm(p => ({ ...p, startDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700" />
                  </div>
                  <div>
                    <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">End Date</label>
                    <input type="date" required value={editForm.endDate} onChange={(e) => setEditForm(p => ({ ...p, endDate: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-xs border-slate-200 text-slate-700" />
                  </div>
                </div>

                <div className="space-y-4 pt-2">
                  <div className="flex justify-between items-center border-b pb-2">
                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Assigned KRAs ({editForm.kras.length})</span>
                    <button type="button" onClick={handleAutoSplitEditWeights} className="text-[10px] text-primary hover:underline font-bold uppercase">Distribute Weights Equally</button>
                  </div>

                  <div className="space-y-4 max-h-[300px] overflow-y-auto pr-1">
                    {editForm.kras.map((k, idx) => (
                      <div key={idx} className="bg-white border rounded-xl p-4 shadow-sm space-y-3">
                        <div className="flex justify-between items-start gap-2">
                          <div>
                            <span className="inline-block bg-slate-100 text-slate-600 text-[8px] font-bold px-1.5 py-0.5 rounded uppercase">{k.category}</span>
                            <h4 className="font-bold text-gray-900 text-xs sm:text-sm mt-1">{k.name}</h4>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2.5 border-t">
                          <div>
                            <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Weightage (%)</label>
                            <input type="number" required value={k.weightage || ""} onChange={(e) => handleEditKrasChange(idx, "weightage", Number(e.target.value) || 0)} className="w-full border border-gray-200 rounded-lg px-2.5 py-1 text-xs font-bold" min={1} max={100} />
                          </div>
                          <div>
                            <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Review Frequency</label>
                            <select value={k.reviewCycle} onChange={(e) => handleEditKrasChange(idx, "reviewCycle", e.target.value)} className="w-full border border-gray-200 rounded-lg px-2 py-1 text-xs font-bold bg-white">
                              <option value="1_WEEK">Weekly</option>
                              <option value="2_WEEKS">Bi-weekly</option>
                              <option value="1_MONTH">Monthly</option>
                              <option value="3_MONTHS">Quarterly</option>
                              <option value="6_MONTHS">Half-Yearly</option>
                              <option value="12_MONTHS">Annual</option>
                            </select>
                          </div>
                          
                          {/* Simplified target setup inside edit modal cards */}
                          <div>
                            <label className="block text-[9px] font-bold text-primary uppercase mb-1">Target *</label>
                            <input 
                              type="text" 
                              required 
                              value={k.targetValue || k.monthlyTarget || k.yearlyTarget || ""} 
                              onChange={(e) => {
                                handleEditKrasChange(idx, "targetValue", e.target.value);
                                handleEditKrasChange(idx, "monthlyTarget", "");
                                handleEditKrasChange(idx, "yearlyTarget", "");
                              }} 
                              className="w-full border border-red-200 rounded-lg px-2.5 py-1 text-xs font-bold" 
                              placeholder="e.g. 25 APIs, 3 Modules" 
                            />
                          </div>

                          {/* ✅ Added Goal Direction Dropdown in edit modal cards to allow metrics logic configuration */}
                          <div>
                            <label className="block text-[9px] font-bold text-gray-700 uppercase mb-1">Goal Direction *</label>
                            <div className="relative">
                              <select
                                value={k.metricType || "HIGHER_IS_BETTER"}
                                onChange={(e) => handleEditKrasChange(idx, "metricType", e.target.value)}
                                className="w-full border border-gray-200 rounded-lg pl-2 pr-5 py-1 text-xs font-bold h-[28px] bg-white outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all shadow-sm appearance-none cursor-pointer"
                              >
                                <option value="HIGHER_IS_BETTER">Higher is Better (Direct)</option>
                                <option value="LOWER_IS_BETTER">Lower is Better (Inverse)</option>
                              </select>
                              <ChevronDown className="absolute right-1.5 top-1/2 -translate-y-1/2 h-3 w-3 text-gray-400 pointer-events-none stroke-[3]" />
                            </div>
                          </div>

                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="pt-2 border-t flex justify-between items-center text-xs font-bold">
                    <span className={totalEditWeightSum === 100 ? "text-green-600" : "text-primary"}>Weightage Sum: {totalEditWeightSum}%</span>
                    <span className="text-gray-400 uppercase text-[9px]">Required Total: 100%</span>
                  </div>
                </div>

              </div>

              <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
                <button type="button" onClick={() => setShowEditModal(false)} className="px-4 py-2 bg-white text-slate-700 border rounded-lg text-xs font-bold uppercase">Cancel</button>
                <button type="submit" disabled={updatingAssignment} className="px-4 py-2 bg-primary text-white rounded-lg text-xs font-bold uppercase">{updatingAssignment ? "Updating..." : "Save Updates"}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* DETAIL WORKSPACE OVERLAY */}
      {selectedAssignment && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl border overflow-hidden flex flex-col max-h-[85vh] animate-in fade-in zoom-in-95 duration-200">
            
            {/* Modal Header */}
            <div className="p-5 border-b flex justify-between items-start gap-4">
              <div className="flex gap-3 items-center">
                <div className="w-10 h-10 rounded-full bg-red-50 text-primary flex items-center justify-center shrink-0 border border-red-100">
                  <Award className="w-5 h-5" />
                </div>
                <div className="text-left">
                  <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-tight">
                    {selectedAssignment.userId?.firstName} {selectedAssignment.userId?.lastName} - Goal Setup Details
                  </h3>
                  <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">
                    FY {selectedAssignment.year} • {formatCycleDisplay(selectedAssignment.reviewCycle)} Setup
                  </p>
                </div>
              </div>
              <button 
                onClick={() => setSelectedAssignment(null)}
                className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-primary rounded-lg transition-colors border"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 overflow-y-auto space-y-4 custom-scrollbar flex-1 bg-slate-50/40 text-left">
              
              <div className="bg-white border rounded-xl p-4 shadow-sm grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs">
                <div>
                  <span className="block text-[10px] text-gray-400 font-bold uppercase">Department</span>
                  <span className="font-bold text-gray-800">{selectedAssignment.userId?.departmentId?.name || "N/A"}</span>
                </div>
                <div>
                  <span className="block text-[10px] text-gray-400 font-bold uppercase">Designation</span>
                  <span className="font-bold text-gray-800">
                    {selectedAssignment.userId?.designationId?.title || selectedAssignment.userId?.designationId?.name || "N/A"}
                  </span>
                </div>
                <div>
                  <span className="block text-[10px] text-gray-400 font-bold uppercase">Cycle Timeline Bounds</span>
                  <span className="font-bold text-gray-800">
                    {formatDateTime(selectedAssignment.startDate, false)} to {formatDateTime(selectedAssignment.endDate, false)}
                  </span>
                </div>
                <div>
                  <span className="block text-[10px] text-gray-400 font-bold uppercase">Allocated By</span>
                  <span className="font-bold text-gray-800">
                    {selectedAssignment.assignedBy?.firstName} {selectedAssignment.assignedBy?.lastName || "HR System Administrator"}
                  </span>
                </div>
                <div>
                  <span className="block text-[10px] text-gray-400 font-bold uppercase">Workflow assigned</span>
                  <span className="font-bold text-gray-800">{selectedAssignment.workflowId?.name || "Standard Workflow"}</span>
                </div>
                <div>
                  <span className="block text-[10px] text-gray-400 font-bold uppercase">Assigned Bundle Reference</span>
                  <span className="font-bold text-gray-800">{selectedAssignment.bundleId?.name || "Custom/Manual Selection"}</span>
                </div>
              </div>

              {selectedAssignment.employeeStatus === "ACKNOWLEDGED" && (
                <div className="bg-green-50 border border-green-100 rounded-xl p-4 text-xs space-y-1.5 shadow-sm">
                  <div className="flex justify-between items-center text-green-700 font-bold">
                    <span className="uppercase text-[9px] tracking-wider">Employee Acknowledged Comment</span>
                    {selectedAssignment.acknowledgedAt && (
                      <span className="text-[9px] font-normal">
                        Date: {formatDateTime(selectedAssignment.acknowledgedAt, false)}
                      </span>
                    )}
                  </div>
                  <p className="text-green-600 leading-relaxed italic">
                    "{selectedAssignment.employeeComment || "Accepted without comments."}"
                  </p>
                </div>
              )}

              {selectedAssignment.employeeStatus === "DISPUTED" && (
                <div className="bg-red-50 border border-red-100 rounded-xl p-4 text-xs space-y-1.5 shadow-sm">
                  <span className="uppercase text-[9px] tracking-wider text-red-700 font-bold">Employee Dispute Remarks</span>
                  <p className="text-red-600 leading-relaxed italic">
                    "{selectedAssignment.employeeComment || "No remarks provided."}"
                  </p>
                </div>
              )}

              {/* Enhanced Goal Visualizer showing targets */}
              <div className="space-y-3">
                <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block">Assigned Key Result Areas (KRAs)</span>
                
                {selectedAssignment.kras?.map((k, kIdx) => (
                  <div key={kIdx} className="bg-white border rounded-xl p-4 shadow-sm space-y-3">
                    <div className="flex justify-between items-start gap-4">
                      <div className="space-y-1 min-w-0">
                        <span className="inline-block bg-slate-100 text-slate-700 text-[9px] font-bold px-2 py-0.5 rounded-full uppercase">
                          {k.category}
                        </span>
                        <h4 className="font-bold text-gray-900 text-sm sm:text-base leading-tight truncate">{k.name}</h4>
                      </div>
                      <span className="bg-red-50 text-primary border border-red-100 text-[10px] font-bold px-2.5 py-0.5 rounded-lg shrink-0">
                        Weight: {k.weightage}%
                      </span>
                    </div>
                    <p className="text-xs text-gray-400 leading-relaxed border-t pt-2 mt-1">{k.description || "No description provided."}</p>
                    
                    {/* Unified simplified target details rendering */}
                    {/* ✅ Upgraded to sm:grid-cols-3 layout to cleanly render Goal/Metric Direction */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-2 pt-2.5 border-t border-dashed border-gray-100 text-[11px] text-gray-500 bg-slate-50/40 p-2.5 rounded-lg">
                      <div>
                        <span className="text-[9px] text-gray-400 font-bold uppercase block">Review Frequency</span>
                        <span className="font-semibold text-gray-700">{formatCycleDisplay(k.reviewCycle)}</span>
                      </div>
                      <div>
                        <span className="text-[9px] text-primary font-bold uppercase block">Target</span>
                        <span className="font-bold text-gray-900">
                          {k.targetValue || k.monthlyTarget || k.yearlyTarget || "N/A"}
                        </span>
                      </div>
                      {/* ✅ Added Goal Direction display */}
                      <div>
                        <span className="text-[9px] text-gray-400 font-bold uppercase block">Goal Direction</span>
                        <span className="font-semibold text-gray-700">
                          {k.metricType === "LOWER_IS_BETTER" ? "Lower is Better" : "Higher is Better"}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>

            <div className="p-4 border-t bg-slate-50 flex justify-end">
              <button
                onClick={() => setSelectedAssignment(null)}
                className="px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 border rounded-lg text-xs font-bold uppercase transition-colors"
              >
                Close View
              </button>
            </div>

          </div>
        </div>
      )}

      {/* Delete Confirmation Offcanvas */}
      <DeleteConfirmationOffcanvas
        isOpen={isDeleteOpen}
        onClose={() => {
          setIsDeleteOpen(false);
          setItemToDelete(null);
          setDeleteError(null);
        }}
        onConfirm={handleConfirmDelete}
        title="Delete KRA Assignment"
        itemName={itemToDelete ? `${itemToDelete.userId?.firstName} ${itemToDelete.userId?.lastName}'s Assignment` : ""}
        error={deleteError}
        isLoading={isDeleting}
        deleteType="hard"
        navigateButtonText="Dismiss"
        onNavigateToUsers={() => {
          setIsDeleteOpen(false);
          setItemToDelete(null);
          setDeleteError(null);
        }}
        onViewUser={() => {}}
      />
    </>
  );
};